import confirmationApi from '../../api/Confirmation/confirmation.api';
import {
	CLOSE_CONFIRMATION_FAIL,
	CLOSE_CONFIRMATION_SUCCESS,
	SET_CONFIRMATION_FAIL,
	SET_CONFIRMATION_SUCCESS,
} from './types';

//opening the confirmation message
export const setConfirmation = (confirmationId) => {
	return async (dispatch) => {
		try {
			confirmationApi(confirmationId, (callback) => {
				var payload = {
					[confirmationId]: true,
					details: callback,
				};

				dispatch(setConfirmationSuccess(payload));
			});
		} catch (error) {
			dispatch(setConfirmationFail(error));
		}
	};
};

//closing the confirmation message
export const closeConfirmation = (confirmationId) => {
	return async (dispatch) => {
		try {
			var payload = {
				[confirmationId]: false,
			};
			dispatch(closeConfirmationSuccess(payload));
		} catch (error) {
			dispatch(closeConfirmationFail());
		}
	};
};

export const setConfirmationSuccess = (payload) => ({
	type: SET_CONFIRMATION_SUCCESS,
	payload,
});

export const setConfirmationFail = (payload) => ({
	type: SET_CONFIRMATION_FAIL,
	payload,
});

export const closeConfirmationSuccess = (payload) => ({
	type: CLOSE_CONFIRMATION_SUCCESS,
});

export const closeConfirmationFail = (payload) => ({
	type: CLOSE_CONFIRMATION_FAIL,
});
